// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"i0-z","displaySixCardTiles":"j0-z"};